import React from "react";
import { Field } from "../Fields";

/** Wartość prostego mapowania opisana przez definicję słownika. */
export default function MappingEntryFields({ definition, value, onChange }) {
  return (
    <Field
      label={definition.valueLabel}
      maxLength={definition.valueMaxLength}
      required
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
